import axios from 'axios'
import {BASE_URL, API_VERSION, TRANSACTIONS} from '../endpoints'

export const GET_ALL_TRANSACTIONS = 'GET_ALL_TRANSACTIONS'
export const ADD_TRANSACTION = 'ADD_TRANSACTION'
export const EDIT_TRANSACTION = 'EDIT_TRANSACTION'
export const DELETE_TRANSACTION = 'DELETE_TRANSACTION'

export const getAllItems = (page, size, search) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken');
    let options = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };

    return axios.get(`${BASE_URL}${TRANSACTIONS}?page=${page}&size=${size}&search=${search}&admin=true`, options)
        .then((response) => {
            dispatch({
                type: GET_ALL_TRANSACTIONS,
                payload: {
                    transactions: response.data.data,
                    total: response.data.data.totalElements // Adjust based on API
                }
            });
            return Promise.resolve(response.data.data);
        })
        .catch((error) => {
            return Promise.reject(error.response?.data?.error);
        });
};



export const addItem = (payload) => (dispatch) => {
    let apiHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }
    }
    return axios.post(BASE_URL + TRANSACTIONS, payload, apiHeader)
        .then(response => {
            console.log(response.data)
            // dispatch({ type: ADD_TRANSACTION, payload: response.data });
            return Promise.resolve()
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}

export const deleteItem = (id) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken')
    let apiHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };
    return axios.delete(BASE_URL + TRANSACTIONS + '/' + id, apiHeader)
        .then(response => {
            // dispatch({ type: DELETE_TRANSACTION, payload: id });
            return Promise.resolve(response.data)
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}

export const editItem = (id, payload) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken')
    let apiHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };
    return axios.patch(BASE_URL + TRANSACTIONS + '/' + id, payload, apiHeader)
        .then(response => {
            // dispatch({ type: EDIT_TRANSACTION, payload: response.data });
            return Promise.resolve()
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}